import React from "react";
import { Answer } from "../../apis";
import { WideButton } from "../atoms/WideButton";

type Props = {
  options: Array<Option>;
  answerQuestion: (answer: Answer) => Promise<void>;
  initCheck?: Option;
  answerable: boolean;
};

export const DateChoieRadio: React.FC<Props> = ({
  options,
  answerQuestion,
  initCheck,
  answerable,
}) => (
  <>
    {options.map(({ value, label }) => (
      <WideButton
        key={value}
        label={label}
        active={initCheck?.value === value}
        onClick={() => {
          const answer = {
            questionType: "DATE_CHOICE",
            value,
          };
          answerQuestion({ answer });
        }}
        disabled={!answerable}
      />
    ))}
  </>
);
